import { NoContentPlaceholder } from "../../../../../components/NoContentPlaceholder.js";
import { RecordCard } from "../../RecordCard.js";
import "react";
import { Icon, Modal } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { MdInventory } from "react-icons/md";
//#region src/modules/Records/shared/RecordPickModal/components/PickedRecordsModal.tsx
function PickedRecordsModal({ closeHandler, onRecordDelete, recordIds }) {
	return /* @__PURE__ */ jsx(Modal, {
		escPressClose: true,
		outsideClickClose: true,
		closeHandler,
		header: "Selected Records",
		children: /* @__PURE__ */ jsx("div", {
			className: "bg-background space-y-xs p-xs rounded",
			children: Array.isArray(recordIds) && !!recordIds.length ? recordIds.map((recordId) => /* @__PURE__ */ jsx(RecordCard, {
				onDelete: onRecordDelete,
				recordId
			}, recordId)) : /* @__PURE__ */ jsx("div", {
				className: "p-xl",
				children: /* @__PURE__ */ jsx(NoContentPlaceholder, {
					icon: /* @__PURE__ */ jsx(Icon, {
						Icon: MdInventory,
						size: "xxl"
					}),
					children: "No Records Selected"
				})
			})
		})
	});
}
//#endregion
export { PickedRecordsModal };

//# sourceMappingURL=PickedRecordsModal.js.map